import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-loader-circular",
    templateUrl: "./loader-circular.component.html",
    styleUrls: ["./loader-circular.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderCircularComponent implements OnInit {
  sizeClass: string = "";

  @Input() size: string;

  constructor() {}

  ngOnInit() {
    switch (this.size) {
      case "xsmall":
        this.sizeClass = "spinner-xsmall";
        break;
      case "small":
        this.sizeClass = "spinner-small";
        break;
      case "medium":
        this.sizeClass = "spinner-medium";
        break;
      case "large":
        this.sizeClass = "spinner-large";
        break;
      case "xlarge":
        this.sizeClass = "spinner-xlarge";
        break;
    }
  }
}
